import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Container,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import DirectionsBusIcon from "@material-ui/icons/DirectionsBus";
import SubwayIcon from "@material-ui/icons/Subway";

declare global {
  interface Window {
    kakao: any;
  }
}

const useStyles = makeStyles((theme) => ({
  topContainer: {
    paddingTop: "10rem",
    paddingBottom: "6rem",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "5rem",
    },
  },
  sidePadding: {
    paddingLeft: "6rem",
    paddingRight: "6rem",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 32,
      paddingRight: 32,
    },
  },
  baseLine: {},
  bigTitle: {
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 16,
    }, // paddingBottom: 8,
  },
  addressStrong: {
    fontStyle: '"Noto Sans KR"',
    // paddingRight: 32,
    fontSize: 20,
    fontWeight: 600,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
    },
  },
  normalText: {
    fontStyle: '"Noto Sans KR"',
    // paddingRight: 32,
    fontSize: 20,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
    },
    // fontWeight: 700,
  },
  containerTitle: {
    fontFamily: "Noto Sans KR",
    fontSize: 64,
    color: "black",
    fontWeight: 900,
    // letterSpacing: -4,

    paddingBottom: 48,
    [theme.breakpoints.down("xs")]: {
      fontSize: 32,
      paddingBottom: 16,
    },
  },
  mapZone: {
    width: "100%",
    height: 500,
    [theme.breakpoints.down("xs")]: {
      // paddingTop: 32,
      height: 200,
    },
  },
  mapContainer: {
    [theme.breakpoints.down("xs")]: {
      paddingTop: 32,
    },
  },
}));

interface MapContainerProps {
  match: any;
  location: any;
  history: any;
}

function MapContainer({ match, location, history }: MapContainerProps) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://dapi.kakao.com/v2/maps/sdk.js?appkey=d45b80038be6a659e7c33193d3ce883e&autoload=false";
    document.head.appendChild(script);
    script.onload = () => {
      window.kakao.maps.load(() => {
        let container = document.getElementById("MyMap"); //지도를 담을 영역의 DOM 레퍼런스
        let options = {
          //지도를 생성할 때 필요한 기본 옵션
          center: new window.kakao.maps.LatLng(
            35.15164113443559,
            129.05753360072117
          ), //지도의 중심좌표.
          level: 1, //지도의 레벨(확대, 축소 정도)
        };

        let map = new window.kakao.maps.Map(container, options); //지도 생성 및 객체 리턴

        let imageSrc = "/images/main/logo.png", // 마커이미지의 주소입니다
          imageSize = new window.kakao.maps.Size(98, 26), // 마커이미지의 크기입니다
          imageOption = { offset: new window.kakao.maps.Point(27, 69) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.

        var markerImage = new window.kakao.maps.MarkerImage(
            imageSrc,
            imageSize,
            imageOption
          ),
          markerPosition = new window.kakao.maps.LatLng(
            35.15160584858484,
            129.05748882327873
          ); // 마커가 표시될 위치입니다

        // 마커를 생성합니다
        var marker = new window.kakao.maps.Marker({
          // position: map.getCenter(),
          position: markerPosition,

          image: markerImage, // 마커이미지 설정
        });

        // 마커가 지도 위에 표시되도록 설정합니다
        marker.setMap(map);

        // let content =
        //   '<div class="customoverlay">' +
        //   '  <a href="https://map.kakao.com/link/map/11394059" target="_blank">' +
        //   '    <span class="title">테스트</span>' +
        //   "  </a>" +
        //   "</div>";

        // 커스텀 오버레이가 표시될 위치입니다
        var position = map.getCenter();

        // 커스텀 오버레이를 생성합니다
        var customOverlay = new window.kakao.maps.CustomOverlay({
          map: map,
          position: position,
          // content: content,
          yAnchor: 1,
        });
        // let marker = new window.kakao.maps.Marker({
        //   // 지도 중심좌표에 마커를 생성합니다
        //   position: map.getCenter(),
        // });
        // marker.setMap(map);
      });
    };
    return () => {};
  }, []);
  return (
    <Container
      maxWidth={false}
      disableGutters
      style={{}}
      className={classes.topContainer}
    >
      <Container
        maxWidth={"xl"}
        disableGutters={true}
        className={classes.sidePadding}
      >
        <Grid
          item
          container
          alignItems={"center"}
          xs={12}
          className={classes.containerTitle}
        >
          <Grid xs={!matches ? 7 : 12} item className={classes.bigTitle}>
            찾아 오시는 길
          </Grid>
          <Grid xs={!matches ? 5 : 12} item>
            <Grid xs={12} item container className={classes.baseLine}>
              <Grid
                xs={3}
                item
                component={"p"}
                className={classes.addressStrong}
              >
                주소
              </Grid>

              <Grid xs={9} item component={"p"} className={classes.normalText}>
                부산광역시 부산진구 서면로 9 2층
              </Grid>
            </Grid>
            <Grid xs={12} item container className={classes.baseLine}>
              <Grid
                xs={3}
                item
                component={"p"}
                className={classes.addressStrong}
              >
                전화번호
              </Grid>

              <Grid xs={8} item component={"p"} className={classes.normalText}>
                051-803-8746
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12} item container className={classes.mapContainer}>
          <Grid xs={12} item id="MyMap" className={classes.mapZone}></Grid>
        </Grid>
      </Container>
    </Container>
  );
}

export default MapContainer;
